import React from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { DICTItem } from 'src/pages/app/_BLL/metaDictionaries/types';
import { GeneratedField } from 'src/pages/CompanyPage/_BLL/types';
import { getFieldNameCompany } from 'src/pages/CompanyPage/lib/getFieldNameCompany';
import { Select } from 'src/shared/ui/_inputs/Select';
import s from './DropDownField.module.scss';

export const DropDownField: React.FC<GeneratedField> = (props) => {
	const {
		namePrefix, //
		propertyName,
		internalName,
		validate,
		fieldDictionary,
	} = props;

	// * Form
	const { setValue, control } = useFormContext();

	const NAME = getFieldNameCompany({ namePrefix, propertyName, internalName });

	// ! Industry and sector ONLY...
	const dictionaryFilter = (dictionary: DICTItem[]): DICTItem[] => {
		if (NAME === primaryIndustryName) {
			if (primarySectorValue) {
				let filteredDictionary: DICTItem[] = [];

				filteredDictionary = [...filteredDictionary, ...dictionary.filter((item) => String(item.id).slice(0, -3) + '000' === primarySectorValue)];

				return filteredDictionary;
			} else {
				return [];
			}
		} else {
			return dictionary;
		}
	};

	// - Primary
	const primarySectorName = 'properties.industryAndSector.sector';
	const primaryIndustryName = 'properties.industryAndSector.industry';

	const primarySectorValue: string | null = useWatch({
		name: `${primarySectorName}.value`,
	});

	const handleChange = (fieldName: string, value: string | null) => {
		setValue(fieldName, value);

		// ! Industry ONLY ...
		// When primary sector value changes nullify primary industry.
		if (NAME === primarySectorName) {
			setValue(`${primaryIndustryName}.value`, null);
		}
		// ! ...
	};

	// * Conditions
	// ! Industry ONLY ...
	const disableIndustry = NAME === primaryIndustryName && primarySectorValue === null;
	// ! ...

	return (
		<Controller
			name={`${NAME}.value`}
			control={control}
			rules={{ validate: validate }}
			render={({ field, fieldState }) => (
				<Select
					{...field}
					className={s.field}
					placement="bottomLeft"
					value={field.value === null ? '' : field.value}
					showSearch
					filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
					options={
						fieldDictionary && [{ value: null, label: 'Unknown' }, ...dictionaryFilter(fieldDictionary).map((dictionary) => ({ value: String(dictionary.id), label: dictionary.name }))]
					}
					onChange={(value) => {
						handleChange(field.name, value);
					}}
					disabled={disableIndustry}
					error={fieldState.error?.message}
					size="middle"
				/>
			)}
		/>
	);
};
